































































// decoradores
import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import { SaldoCuenta } from "@/typings/store/plugins/easyFirestore/saldoCuentas";
import SVGIcon from "@/components/SVGIcon.vue";
// tipos

// tipos
@Component({
  components: {
    SVGIcon,
  },
})
export default class InfoSaldoCuenta extends Vue {
  @Prop() readonly saldoCuenta!: SaldoCuenta;
  @Prop({ type: Boolean }) readonly showTitulo!: boolean;

  get id(): string {
    return this.saldoCuenta.id || "N/R";
  }

  get nombre(): string {
    return this.saldoCuenta.nombre || "N/R";
  }

  get posicion(): string {
    return this.saldoCuenta.posicion || "N/R";
  }


  @Emit("cerrar")
  onCerrar(): void {
    return;
  }
}
